import { render, staticRenderFns } from "./ClientCampaignsPerformance.vue?vue&type=template&id=13b2a801&"
import script from "./ClientCampaignsPerformance.vue?vue&type=script&lang=ts&"
export * from "./ClientCampaignsPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCampaignsPerformance.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCard,VCol,VRow})
